import EmailRoundedIcon from "@mui/icons-material/EmailRounded";

export const email = (props) => {
  return <EmailRoundedIcon {...props} />;
};
